import { isAxiosError } from "axios";
import { useState } from "react";
import { api } from "../../utils/api";

export const useQRCodeValidation = (token: string | null, id: string | null) => {
    const [isValid, setIsValid] = useState<boolean | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const validateQRCodeSignIn = async (code: string) => {
            if (!token || !id) return;
    
            setLoading(true);
            setError(null);
    
            try {
            const res = await api.post(
                `/auth-user/auth-code-sign-in-user-valdation/${id}`,
                { code },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            console.log(res.data);
            setIsValid(true);
            } catch (err) {
                if (isAxiosError(err)) {
                    const backendError =
                    err.response?.data?.errors?.code || // <-- ось правильний шлях
                    err.response?.data?.message ||      // запасний варіант
                    err.message;
    
                    console.error("Validation error:", backendError);
                    setError(backendError);
                } else if (err instanceof Error) {
                    setError(err.message);
                } else {
                    setError("Unknown error");
                }
    
                setIsValid(false);
            }
    };
    
    return { validateQRCodeSignIn, loading, error, isValid };
}